import ImportStatus from "@/onboarding/features/import/ImportStatus"
import Slice from "@/onboarding/features/import/Slice"
import { withApp } from "@/components/App"

export default withApp(ImportStatus, { slices: [Slice] })
